module.exports = __webpack_public_path__ + "static/img/292_TO8_1958_og.71c57c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/292_TO8_1958_og.jpg
// module id = 8mm1
// module chunks = 0